<template>
  <modal @modal-close="handleClose">
    <form
      class="bg-white rounded-lg shadow-lg overflow-hidden w-full mx-auto"
      @submit.prevent="handleConfirm"
    >
      <slot :uppercase-mode="uppercaseMode" :mode="mode">
        <div class="p-8">
          <Heading :level="2" class="mb-6">{{ $t(`${uppercaseMode} Resource`) }}</Heading>
          <p class="text-80 leading-normal">
            {{ $t(`Are you sure you want to ${mode} the selected resources?`) }}
          </p>
        </div>
      </slot>

      <div class="bg-30 px-6 py-3 flex">
        <div class="ml-auto">
          <button
            type="button"
            data-testid="cancel-button"
            dusk="cancel-delete-button"
            class="btn text-80 font-normal h-9 px-3 mr-3 btn-link"
            @click.prevent="handleClose"
          >
            {{ $t('Cancel') }}
          </button>
          <button
            id="confirm-delete-button"
            ref="confirmButton"
            data-testid="confirm-button"
            type="submit"
            class="btn btn-default btn-danger"
          >
            {{ $t(uppercaseMode) }}
          </button>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>
  import _ from 'lodash';
  import Heading from '@/_legacy/components/Heading.vue';

  export default {
    components: {
      Heading,
    },
    props: {
      mode: {
        type: String,
        default: 'delete',
        validator(value) {
          return ['force delete', 'delete', 'detach'].indexOf(value) !== -1;
        },
      },
    },
    computed: {
      uppercaseMode() {
        return _.startCase(this.mode);
      },
    },
    mounted() {
      this.$refs.confirmButton.focus();
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },
      handleConfirm() {
        this.$emit('confirm');
      },
    },
  };
</script>

<style scoped>
  form {
    max-width: 460px;
  }
</style>
